import { render } from "./BaseDivider.vue?vue&type=template&id=ce37ac74&scoped=true"
import script from "./BaseDivider.vue?vue&type=script&lang=js"
export * from "./BaseDivider.vue?vue&type=script&lang=js"

import "./BaseDivider.vue?vue&type=style&index=0&id=ce37ac74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce37ac74"]])

export default __exports__